module.exports = __webpack_public_path__ + "static/media/summaryTicket.70b1f8cc.svg";